import { NsInputter } from 'components/common/ns-inputter/NsInputter';
import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import { NsInput } from 'components/common/ns-input/NsInput';
import {
  METER_READS_MIN_DIGITS,
  METER_READS_DEFAULT_MAX_DIGITS
} from 'config/app-config';

const maskChar = '-';

type NsMeterReadInputProps = {
  id?: string;
  label?: string;
  name?: string;
  onChange?: () => void;
  value?: string;
  inputAttributes?: Record<string, string | boolean>;
  digits?: number;
  testId?: string;
};

export const NsMeterReadInput = ({
  id = 'meterRead',
  name = 'meterRead',
  label = 'Reading',
  value,
  onChange,
  digits = METER_READS_DEFAULT_MAX_DIGITS,
  testId,
  inputAttributes = {}
}: NsMeterReadInputProps) => {
  let maxDigit = digits || METER_READS_DEFAULT_MAX_DIGITS;
  if (maxDigit < METER_READS_MIN_DIGITS) {
    maxDigit = METER_READS_MIN_DIGITS;
  }
  const validations = [
    NsInputterValidations.isNumber,
    NsInputterValidations.isBetween(METER_READS_MIN_DIGITS, maxDigit)
  ];

  const mask = maskChar.repeat(maxDigit);

  return (
    <NsInputter
      validation={validations}
      value={value}
      mask={mask}
      name={name}
      onChange={onChange}
    >
      <NsInput
        label={label}
        name={name}
        id={id}
        testId={testId}
        inputAttributes={inputAttributes}
      />
    </NsInputter>
  );
};
